import { createActionBarEffect } from '@databases/action-bar/selections-effect';
import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { type DatabaseAdapter } from '@databases/selections-api-types';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface ActionBarEffectFeatureLifecycleDeps {
  contentId: string;
  databaseAdapter: DatabaseAdapter;
}

export const isActionBarSupportedLayoutType = (layoutType: DatabaseLayoutType): boolean =>
  layoutType === DatabaseLayoutType.TABLE || layoutType === DatabaseLayoutType.TIMELINE;

export function createActionBarEffectFeature(
  lifecycleDeps: ActionBarEffectFeatureLifecycleDeps,
): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.ACTION_BAR_EFFECT,
    type: 'effect',
    // Always active — the action bar is read-only selection UI.
    factory: () =>
      createActionBarEffect({
        selectionsApi: getService('SelectionsApi'),
        contentId: lifecycleDeps.contentId,
        databaseAdapter: lifecycleDeps.databaseAdapter,
        panelManager: getService('PanelManager'),
        isActionBarSupportedLayout: () =>
          isActionBarSupportedLayoutType(
            getCachedViewSnapshotForSelections().settings.layout.type,
          ),
      }),
  };
}
